<template>
  <div class="recount">
    <template v-if="!lpo.inspection_type_id"> </template>

    <template v-else>
      <template>
        <PlotsStrip v-if="lpo.inspection_type_id === '1'" />
        <PlotsCircle v-if="lpo.inspection_type_id === '4'" />
        <PlotsRel v-if="lpo.inspection_type_id === '2'" />
        <PlotsSolid v-if="lpo.inspection_type_id === '3'" />
        <PlotsVb v-if="lpo.inspection_type_id === '5'" />
        <PlotsVisualLand v-if="lpo.inspection_type_id === '7'" />
        <AviaResults v-if="lpo.inspection_type_id === '9'"/>
        <DnDeshifResults v-if="lpo.inspection_type_id === '10'"/>
      </template>

      <!-- <button @click='openRecountEdit'>Открыть</button> -->

      <div v-if="plotList.length && plotList[0].is_draft === 'f'">
        <ModelTreesRel v-if="lpo.inspection_type_id === '2'" />
        <ModelTrees v-else />
      </div>
      <template>
        <PMessage v-if="['1','2','3','4'].includes(lpo.inspection_type_id) && modelTreesAreOpen && modelTreesExist" severity="error" :closable="false">
          Для установки главной причины необходимо закрыть редактирование списка модельных деревьев
        </PMessage>
        <MainDamagePicker v-if="['1','2','3','4'].includes(lpo.inspection_type_id) && !modelTreesAreOpen && modelTreesExist" :key="NaN" />
        <PMessage v-if="['5','7'].includes(lpo.inspection_type_id) && !bvRecountCheck" severity="error" :closable="false">
          Для установки главной причины необходимо корректно заполнить ведомость
        </PMessage>
        <MainDamagePicker v-if="['5','7'].includes(lpo.inspection_type_id) && bvRecountCheck" :key="NaN" />
      </template>
    </template>
  </div>
</template>

<script>
import PlotsStrip from "./Recount__instrum/Recount__plotsLent";
import PlotsCircle from "./Recount__instrum/Recount__plotsCircle";
import PlotsRel from "./Recount__instrum/Recount__plotsRel";
import PlotsSolid from "./Recount__instrum/Recount__plotsSolid";
import PlotsVb from "./Recount__visualLand/Recount__plotsBv";
import PlotsVisualLand from "./Recount__visualLand/RecountVisualLand__plots";
import DnDeshifResults from "./Recount__visualRemote/RecountVisualRemote__dnDeshifResults";
import AviaResults from "./Recount__visualRemote/RecountVisualRemote__aviaResults.vue";
import { mapState, mapGetters, mapActions } from 'vuex';
import ModelTrees from "./Recount__instrum/Recount__models";
import ModelTreesRel from "./Recount__instrum/Recount__modelsRel";

import MainDamagePicker from "./Recount__mainDamagePicker";

export default {
  name: "InspectionRecount",
  components: {
    PlotsStrip,
    PlotsCircle,
    PlotsRel,
    PlotsSolid,

    ModelTrees,
    ModelTreesRel,

    PlotsVb,
    PlotsVisualLand,
    DnDeshifResults,
    AviaResults,
    MainDamagePicker,
  },
  computed: {
    lpo() {
      return this.$store.state.selectedLpo.lpo;
    },
    ...mapGetters('selectedLpo/recount', [
				'modelTreesAreOpen',
				'modelTreesExist',
        'bvRecountCheck'
			]),
    plotList() {
      return this.$store.state.selectedLpo.recount["plotList"];
    },
    inspectionType() {
      if (
        this.lpo.inspection_type_id === "1" ||
        this.lpo.inspection_type_id === "2" ||
        this.lpo.inspection_type_id === "3" ||
        this.lpo.inspection_type_id === "4"
      ) {
        return "instrum";
      }

      if (this.lpo.inspection_type_id === "5") {
        return "bv";
      }

      if (this.lpo.inspection_type_id === "6") {
        return "av";
      }
    },
  },
};
</script>

<style scoped></style>
